// Import and register Stimulus controllers without relying on bundler-specific helpers.
import { application } from './application';

import HelloController from './hello_controller';
import SsoLoginController from './sso_login_controller';
import CommentSortController from './comment_sort_controller';
import CommentFormController from './comment_form_controller';
import CommentMentionsController from './comment_mentions_controller';
import RichTextMentionsController from './rich_text_mentions_controller';
import TiptapMentionsController from './tiptap_mentions_controller';
import LocalTimeController from './local_time_controller';
import PostsIndexController from './posts_index_controller';
import CommentLoaderController from './comment_loader_controller';
import DeepLinkingController from './deep_linking_controller';
import CopyLinkController from './copy_link_controller';
import CommentsPanelController from './comments_panel_controller';
import AuthorMultiselectController from './author_multiselect_controller';
import RelatedEntitiesController from './related_entities_controller';
import EntitySelectorController from './entity_selector_controller';
import PostLockChannelController from './post_lock_channel_controller';
import PostLockPollingController from './post_lock_polling_controller';
import PostAutosaveController from './post_autosave_controller';
import ResourceSearchController from './resource_search_controller';
import FlatFeedV3Controller from './flat_feed_v3_controller';
import FeedCategoryDropdownController from './feed_category_dropdown_controller';
import PlyrController from './plyr_controller';
import AnnouncementModalController from './announcement_modal_controller';
import AnnouncementCtaTrackerController from './announcement_cta_tracker_controller';
import FeedSearchDropdownController from './feed_search_dropdown_controller';
import LeftSidebarController from './left_sidebar_controller';
import SearchNoResultAnalyticsController from './search_no_result_analytics_controller';
import PostCarouselController from './post_carousel_controller';
import CommentsSortDropdownController from './comments_sort_dropdown_controller';

application.register('local-time', LocalTimeController);

application.register('hello', HelloController);
application.register('sso-login', SsoLoginController);
application.register('comment-sort', CommentSortController);
application.register('comment-form', CommentFormController);
application.register('comment-mentions', CommentMentionsController);
application.register('rich-text-mentions', RichTextMentionsController);
application.register('tiptap-mentions', TiptapMentionsController);
application.register('posts-index', PostsIndexController);
application.register('comment-loader', CommentLoaderController);
application.register('deep-linking', DeepLinkingController);
application.register('copy-link', CopyLinkController);
application.register('comments-panel', CommentsPanelController);
application.register('author-multiselect', AuthorMultiselectController);
application.register('related-entities', RelatedEntitiesController);
application.register('entity-selector', EntitySelectorController);
application.register('post-lock-channel', PostLockChannelController);
application.register('post-lock-polling', PostLockPollingController);
application.register('post-autosave', PostAutosaveController);
application.register('resource-search', ResourceSearchController);
application.register('flat-feed-v3', FlatFeedV3Controller);
application.register('feed-category-dropdown', FeedCategoryDropdownController);
application.register('plyr', PlyrController);
application.register('announcement-modal', AnnouncementModalController);
application.register('announcement-cta-tracker', AnnouncementCtaTrackerController);
application.register('feed-search-dropdown', FeedSearchDropdownController);
application.register('left-sidebar', LeftSidebarController);
application.register('search-no-result-analytics', SearchNoResultAnalyticsController);
application.register('post-carousel', PostCarouselController);
application.register('comments-sort-dropdown', CommentsSortDropdownController);
